import { Component } from '@angular/core';

@Component({
  selector: 'app-hidden-menu',
  templateUrl: './hidden-menu.component.html',
  styleUrls: ['./hidden-menu.component.scss']
})
export class HiddenMenuComponent {

}
